import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/nations',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/settings/nation/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/nations/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/nations',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/nations/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/nations/${id}`,
      method: 'delete',
  })
}
